import {Component, OnInit, inject, input, computed, effect, signal} from '@angular/core';
import {AdsService} from "../../../core/services/ads.service";
import {Ad} from "../../../core/models/cms/ads.model";
import {UserService} from "../../../core/services/user.service";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";

@Component({
  selector: ' app-skyscraper',
  templateUrl: './skyscraper.component.html',
  standalone: false,
  styleUrl: './skyscraper.component.scss'
})
export class SkyscraperComponent implements OnInit {
  private readonly adsService = inject(AdsService);
  private readonly userService = inject(UserService);
  private readonly router = inject(Router);
  protected readonly CDN = inject('CDN' as any) as string;

  position = input.required<'left' | 'right'>();
  selected = signal<Ad | null>(null);

  readonly altText = computed(() =>
      this.position() === 'left'
          ? 'Phoenix Apothekenportal Links Skyscraper Ad'
          : 'Phoenix Apothekenportal Rechts Skyscraper Ad'
  );

  constructor() {
    effect(() => {
      const allAds = this.position() === 'left'
          ? this.adsService.leftAds()
          : this.adsService.rightAds();

      if (allAds.length === 0) {
        this.selected.set(null);
        return;
      }

      const pool = this.buildPool(allAds);
      const current = this.selected();

      if (!current || !pool.some(a => a.id === current.id)) {
        this.selected.set(pool[Math.floor(Math.random() * pool.length)]);
      }
    });
  }

  ngOnInit(): void {
    this.router.events.pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(() => {
      this.pickNewAd();
    });
  }

  private pickNewAd(): void {
    const allAds = this.position() === 'left'
        ? this.adsService.leftAds()
        : this.adsService.rightAds();

    const pool = this.buildPool(allAds);
    if (pool.length === 0) return;

    const current = this.selected();

    if (current && pool.length > 1) {
      const candidates = pool.filter(a => a.id !== current.id);
      this.selected.set(candidates[Math.floor(Math.random() * candidates.length)]);
    } else if (!current) {
      this.selected.set(pool[Math.floor(Math.random() * pool.length)]);
    }
  }

  private buildPool(allAds: Ad[]): Ad[] {
    if (this.userService.isAdmin()) return allAds;
    const prio = allAds.filter(a => a.prioritized);
    return prio.length > 0 ? prio : allAds;
  }
}
